import { Theme } from '@mui/material/styles';

export default function getShadow(theme: Theme, shadow: string) {
  // Safety check: if customShadows is not defined, return appropriate fallback shadows
  if (!theme.customShadows) {
    // Return appropriate fallback shadows based on the requested shadow type
    if (shadow.includes('Button')) {
      return '0 2px 4px rgba(0, 0, 0, 0.1)';
    }
    return '0 0 0 2px rgba(0, 0, 0, 0.1)';
  }

  switch (shadow) {
  case 'secondary':
    return theme.customShadows.secondary;
  case 'error':
    return theme.customShadows.error;
  case 'warning':
    return theme.customShadows.warning;
  case 'info':
    return theme.customShadows.info;
  case 'success':
    return theme.customShadows.success;
  case 'primaryButton':
    return theme.customShadows.primaryButton;
  case 'secondaryButton':
    return theme.customShadows.secondaryButton;
  case 'errorButton':
    return theme.customShadows.errorButton;
  case 'warningButton':
    return theme.customShadows.warningButton;
  case 'infoButton':
    return theme.customShadows.infoButton;
  case 'successButton':
    return theme.customShadows.successButton;
  default:
    return theme.customShadows.primary;
  }
}
